import React from 'react';
import PrivacyPolicy from 'components/PrivacyPolicy';
import i18n from 'i18n';
import useTitle from 'utils/hook/useTitle';

export const PrivacyPolicyPage = () => {
  useTitle(i18n.t('MB_PRIVACY_POLICY'));

  return <PrivacyPolicy />;
};

export default PrivacyPolicyPage;
